import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import { useState, useEffect } from "react";
import { useTheme } from '@mui/material/styles';
import { Card, Box } from '@mui/material';
import { fNumber } from '../../../utils/formatNumber';
import { BaseOptionChart } from '../../charts';

function AppAgesBar(props) {

  const [CHART_DATAAges, setCHART_DATAAges] = useState([]);

    useEffect(() => {
    if (props.patients.age) {
      const data = props.patients.age;
      const dataWithNulls = [
      data[0],
      data[1],
      data[2],
      null,      // index 3
      data[3],
      data[4],
      null,      // index 6
      data[5],
      data[6]
    ];
      setCHART_DATAAges([{ data: dataWithNulls }]);
    };
  }, [props.patients.age]);

  const chartOptions_AgesBar = merge(BaseOptionChart(), {
    tooltip: {
      enabled: false
    },
    grid: {
      borderColor: "transparent",
      row: { colors: ["transparent"], opacity: 0.5 }
    },
    xaxis: {
      categories: [
        "<1", "1-6", "7-17", "", 
        "18-29", "30-49", "", 
        "50-69", ">=70", "", 
      ],
      labels: {
        style: { fontSize: '13px' }
      }
    },
    colors: ['#3E8397', '#3E8397', '#3E8397', '#FFFFFF', '#5ca8bc', '#5ca8bc', '#FFFFFF', '#92c5d3', '#92c5d3', '#FFFFFF', '#c9e2e9', '#c9e2e9'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '70%',
        distributed: true,
        borderRadius: 6,
        dataLabels: {
          position: "top", // Put labels on top
        }
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20, // Move label upward (adjust as needed)
      formatter: (val) => val ? fNumber(val) : "",
      style: { colors: ['#708090'] },
    },
    legend: { show: false },
    yaxis: { show: false },
    stroke: { show: false }
  });

  return (
    <Card sx={{ boxShadow: 'none', mt: 4 }}>
      <Box sx={{ mx: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATAAges} options={chartOptions_AgesBar} height={280} />
      </Box>
    </Card>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  patients: state.overview.patients
});

const mapDispatch = ({ overview: { loadData } }) => ({
  loadData: () => loadData()
});

export default connect(mapState, mapDispatch)(AppAgesBar);
